import Immutable from 'immutable';
import { STATUS } from './constants';

export const getAttachmentsStatus = (
  state,
  classId,
  attachmentType,
  objectId
) =>
  state.attachments.getIn(
    ['schoolClasses', `${classId}`, attachmentType, `${objectId}`, 'status'],
    STATUS.UNINITIALIZED
  );

export const getAttachments = (
  state,
  classId,
  attachmentType,
  objectId,
  includeTeacherAttachments = false
) =>
  state.attachments
    .getIn(
      ['schoolClasses', `${classId}`, attachmentType, `${objectId}`, 'data'],
      Immutable.Map()
    )
    .filter(
      (attachment) =>
        includeTeacherAttachments || attachment.get('show_to_students')
    );
